import { render } from "./over-limit-warning.vue?vue&type=template&id=593f5ad5&lang=pug"
import script from "./over-limit-warning.vue?vue&type=script&lang=js"
export * from "./over-limit-warning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__